<template>
  <v-flex xs12 md6>
    <v-card>
      <v-card-title>
        <v-icon left>mdi-arrow-decision-auto-outline</v-icon>
        Applications by Campaign
        <v-spacer />
        <v-progress-circular v-if="applications.loading"
          indeterminate :size="20" :width="1"
          :color="themes.client.light.input"
        />
      </v-card-title>
      <v-divider />
      <v-card-text>
        <apex
          v-if="!applications.loading"
          type="pie"
          width="100%"
          :height="400"
          :options="{
            labels: Object.keys(applications),
            colors,
            chart: { fontFamily: 'Heebo, sans-serif', toolbar: { show: true }  },
            tooltip: { enabled: true },
            legend: { position: 'bottom' },
          }"
          :series="Object.values(applications)"
        />
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
// Data
import colors from '@/data/colors'

// Vue Component
export default {
  created() {
    Vue.$http.get(`client/organization/analytics/campaign_applications`).then(({ data }) => (this.applications = data))
  },
  data() {
    return {
      colors: colors.analytics,
      applications: { loading: true },
    }
  },
}
</script>
